export const recipeRoutes = [
    {
        path: '/recipes',
        meta: { requiresHousehold: true },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "recipe" */ '@/features/recipe/views/Recipes.vue'),
          },
          {
            path: ':id',
            children: [
              {
                path: '',
                component: () => import(/* webpackChunkName: "recipe" */ '@/features/recipe/views/RecipeDetails.vue'),
              }
            ]
          },
          {
            path: 'categories',
            component: () => import(/* webpackChunkName: "recipe" */ '@/features/recipe/views/RecipeCategories.vue'),
          },
        ]
    }
]
